export default __webpack_public_path__ + "static/media/buttonsRewardImg.bb94bab3.png";